var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352 96V0H152a24 24 0 0 0-24 24v368a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24V96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 392V96H24a24 24 0 0 0-24 24v368a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24v-40H152a56.06 56.06 0 0 1-56-56zM441 73L375 7a24 24 0 0 0-17-7h-6v96h96v-6.06A24 24 0 0 0 441 73z","className":"fa-primary","key":2})]);
}

Copy.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Copy;

Copy.default = Copy;
